import './index.scss'
import fullpage from 'fullpage.js'
import 'fullpage.js/dist/fullpage.min.css'
import '../../assets/scripts/jquery.mousewheel'
import Swiper from 'swiper/swiper-bundle.min'


$(document).ready(function(){
  if($(window).width() > 1024){
    initFullpage()
  }
  let navLeft = $('.quality-left-menu li.active').offset().left - 20
  $('.quality-left-menu').scrollLeft(navLeft)
})

//全屏滚动
var afullpage;
function initFullpage() {
  afullpage = new fullpage('#fullpage', {
    scrollingSpeed: 600,
    css3: true,
    resize:true,
    autoScrolling: true,
    scrollBar: false,
    anchors: ['page1', 'page2'],
    afterLoad: function (origin, destination, direction, trigger) {
      let i = destination.index;

      if(i == 1){
        afullpage.setAllowScrolling(false);
      }

      if(i == 0){
        if(!$('.section1 .ny-leaf-cont').hasClass('show')){
          $('.section1 .ny-leaf-cont').addClass('show')
        }
      }else if(i == 1){
        if(!$('.section2 .ny-leaf-cont').hasClass('show')){
          $('.section2 .ny-leaf-cont').addClass('show')
        }
      }
    },
    onLeave: function (origin, destination, direction,trigger) {}
  });
}


//底部footer效果
function footerF(event, delta){
  let footerH = $('.fixed-footer').outerHeight()
  if(delta > 0){//返回，上滚
    if(!$('.fixed-footer').hasClass('show')){
      afullpage.setAllowScrolling(true);
    }else{
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.trans-menu').css('transform','translateY(-50%)')
    }
  }else if(delta < 0){//下滚，显示footer
    if(!$('.fixed-footer').hasClass('show')){
      $('.fixed-footer').addClass('show')
      $('.footer-tran').css('transform','translateY('+ -footerH +'px)')
      $('.trans-menu').css('transform',' translateY(calc(-50% - '+ footerH +'px))')
    }
  }
  event.preventDefault();
}

if($(window).width() > 1024){
  $('#fullpage .section2').bind('mousewheel',function(event, delta) {
    footerF(event, delta)
  });
  $('.fixed-footer').mousewheel(function(event, delta) {
    if(delta > 0){//返回，上滚
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.trans-menu').css('transform','translateY(-50%)')
    }
    event.preventDefault();
  });
}

var swiper1 = new Swiper(".section1 .right .mySwiper", {
  speed: 600,
  watchOverflow: true,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.section1 .right .swiper-button-next',
    prevEl: '.section1 .right .swiper-button-prev'
  },
  pagination: {
    el: ".section1 .right .swiper-pagination",
    clickable: true
  },
});

var swiper2 = new Swiper(".section2 .right .mySwiper", {
  speed: 600,
  watchOverflow: true,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.section2 .right .swiper-button-next',
    prevEl: '.section2 .right .swiper-button-prev'
  },
  pagination: {
    el: ".section2 .right .swiper-pagination",
    clickable: true
  },
});

// 叶子效果跟随鼠标位移效果
var viewH = $(window).height()
var vieww = $(window).width()
$('#fullpage .section1').mousemove(function(e){
  $('#fullpage .section1 .ny-leaf-cont .leaf6').css('transform','translate3d('+(e.pageX-vieww/2)/50+'px,'+(e.pageY-viewH/2)/50+'px,0)')
  $('#fullpage .section1 .ny-leaf-cont .leaf7').css('transform','translate3d('+-(e.pageX-vieww/2)/40+'px,'+-(e.pageY-viewH/2)/40+'px,0)')
  $('#fullpage .section1 .ny-leaf-cont .leaf5').css('transform','translate3d('+(e.pageX-vieww/2)/50+'px,'+(e.pageY-viewH/2)/50+'px,0)')
})
$('#fullpage .section2').mousemove(function(e){
  $('#fullpage .section2 .ny-leaf-cont .leaf2').css('transform','translate3d('+-(e.pageX-vieww/2)/40+'px,'+-(e.pageY-viewH/2)/40+'px,0)')
  $('#fullpage .section2 .ny-leaf-cont .leaf3').css('transform','translate3d('+(e.pageX-vieww/2)/50+'px,'+(e.pageY-viewH/2)/50+'px,0)')
})